import { Box, BoxProps, styled } from '@mui/material';

export const StyledSignalsFlexBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap'
}));

export const StyledSignalsInnerBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
